import React from 'react'
import withStyles from 'react-jss'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import popinStyles from './popin-style'

const Popin = props =>
  <div className={classNames(props.classes.overlay, { [props.classes.isOpened]: props.isOpened, [props.classes.isInitialized]: props.isInitialized })}>
    <div className={props.classes.dialog}>
      <div className={props.classes.container} onClick={props.handleContentClick}>
        <div className={props.classes.closeContainer}><span className={props.classes.closeButton} onClick={props.handleLayerClick}>×</span></div>
        {props.title && <p className={props.classes.title}>{props.title}</p>}
        <div className={props.classes.text}>
          {props.children}
        </div>
      </div>
    </div>
  </div>

Popin.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpened: PropTypes.bool.isRequired,
  handleLayerClick: PropTypes.func.isRequired,
  handleContentClick: PropTypes.func.isRequired,
  title: PropTypes.string,
}

export default withStyles(popinStyles)(Popin)
